import * as TYPE from '../types';
import axios from 'axios';
import { api } from '../static';
import { toast } from 'react-toastify';
import mergeSort from '../../src/utils/mergeSort';

export function fetchMerchantList() {
  return async (dispatch) => {
    return new Promise((resolve, reject) => {
      // Use setTimeout to defer the API call to the next tick
      // This helps keep the UI responsive during API calls
      setTimeout(() => {
        axios
          .get(process.env.BASE_URL + api.merchantList, {
            headers: {
              authorization: localStorage.getItem('token'),
            },
            params: {
              skipLoader: true,
            },
          })
          .then((res) => {
            if (res.data.data) {
              let arr = res.data.data.map((u) => ({
                name: u.short_name,
                id: u.id,
                m_id: u.m_id,
              }));
              let final = mergeSort(arr);

              // Use requestAnimationFrame to update the UI in sync with the browser's render cycle
              requestAnimationFrame(() => {
                dispatch({ type: TYPE.MERCHANT_LIST_FOUND, payload: [...final] });
                resolve(final);
              });
            } else {
              resolve([]);
            }
          })
          .catch((error) => {
            toast.error('Unable to fetch merchants', {
              position: 'top-center',
              autoClose: 3000,
            });
            reject(error);
          });
      }, 0);
    });
  };
}
